import { connect } from 'react-redux';
import MapAIChatbot from '../components/MapAIChatbot';
import ChatbotActions from '../redux/ChatbotRedux';

const mapStateToProps = ({ chatbot, display, userAccount }) => ({
  sessionId:          chatbot.sessionId,
  messages:           chatbot.messages,
  currentProposalId:  chatbot.currentProposalId,
  suggestReset:       chatbot.suggestReset,
  sendingMessage:     chatbot.sendingMessage,
  confirmingProposal: chatbot.confirmingProposal,
  chatbotError:       chatbot.error,
  campaignId:         display.editCampaign && display.editCampaign.id,
  userId:             userAccount.user && userAccount.user.id,
});

const mapDispatchToProps = dispatch => ({
  onInitSession:     sessionId => dispatch(ChatbotActions.initSession(sessionId)),
  onSendMessage:     (campaignId, userId, text) =>
    dispatch(ChatbotActions.sendMessageRequest(campaignId, userId, text)),
  onConfirmProposal: (proposalAction, confirmed, checkedIds) =>
    dispatch(ChatbotActions.confirmProposalRequest(proposalAction, confirmed, checkedIds)),
  onResetSession:    () => dispatch(ChatbotActions.resetSessionRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MapAIChatbot);
